import script from "./Participant.vue?vue&type=script&setup=true&lang=js"
export * from "./Participant.vue?vue&type=script&setup=true&lang=js"

import "./Participant.vue?vue&type=style&index=0&id=a76cba18&lang=scss&scoped=true"

import exportComponent from "D:\\project2025\\luck-draw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a76cba18"]])

export default __exports__